function typeObj(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1) === 'Object'
  }
  function typeArr(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1) === 'Array'
  }
  function stringify(data, flag) {
    var str = '',
      originData,
      encodeData;
    if (typeObj(data) || typeArr(data)) {
      for (var i in data) {
        if (data.hasOwnProperty(i)) {
          originData = data[i]
          if (typeObj(originData) || typeArr(originData)) {
            str += stringify(originData, i)
          } else {
            if (encodeURIComponent(originData) != 'undefined') {
              encodeData = encodeURIComponent(originData)
              if (typeObj(data) && flag) {
                str += `${flag}[${i}]=${encodeData}&`
              } else if (typeArr(data) && flag) {
                str += `${flag}[${i}]=${encodeData}&`
              } else {
                if (str.length > 0 && str[str.length - 1] !== '&') str += '&';
                str += `${i}=${encodeData}&`
  
              }
            }
          }
        }
      }
      return str[str.length - 1] === '&' ? str.slice(0, -1) : str
    } else {
      return data
    }
  }
  export default stringify